module.exports = __webpack_public_path__ + "static/img/usFlag.6b7773f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/usFlag.svg
// module id = Tou3
// module chunks = 66